import React, { useEffect, useRef } from "react";

import HeroSection from "./components/HeroSection/HeroSection";
import LisbonMap from "./components/LisbonMap/LisbonMap";
import Areas from "./components/Areas/Areas";
import Partners from "./components/Partners/Partners";
import WhyRecycling from "./components/WhyRecycling/WhyRecycling";

const Home = () => {
  return (
    <>
      <HeroSection />
      <Partners />
      <LisbonMap />
      <Areas />
      <WhyRecycling />
    </>
  );
};

export default Home;
